import axios from "../api"
import { getToken } from "../util/util"

/**
 * Run a natural-language candidate search against the sourcing API.
 *
 * @param {{
 *   query: string,
 *   options?: { high_freshness?: boolean, reveal_emails?: boolean, reveal_phones?: boolean },
 *   pagination?: { limit?: number, offset?: number }
 * }} body
 * @returns {Promise<{
 *   session_id: string,
 *   results: Array<Record<string, any>>,
 *   pagination: { total_estimate: number, offset: number, limit: number, has_more: boolean }
 * }>}
 */
export const sourcingSearch = (body) =>
  axios
    .post("/sourcing/search", body, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
        "Cache-Control": "no-cache",
      },
      // Sourcing searches can take a while — Pearch fast mode usually <10s but
      // we give plenty of headroom here so a slow upstream doesn't trip the
      // global 20s axios default.
      timeout: 300_000,
    })
    .then((res) => res.data)

/**
 * Pull selected profiles from a cached search session into the workspace.
 *
 * @param {{ session_id: string, selected_ids: string[] }} body
 * @returns {Promise<{ task_ids: string[], status: string, message: string }>}
 */
export const sourcingIngest = (body) =>
  axios
    .post("/sourcing/ingest", body, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
        "Cache-Control": "no-cache",
      },
    })
    .then((res) => res.data)
